// import { Divider } from "@wordpress/components/build-types/divider";

//
jQuery(document).ready(function ($) {
    var $window = $(window),
        $html = $("html"),
        $adminBar,
        adminBarVisibleHeight,
        scrollT,
        scrollUp = false,
        sauvScroll = 0,
        w = window,
        $triggerMobile = $("#header_trigger");

    // Sous-menu
    const $navs_items = $('.nav_i-sub');
    $navs_items.find('> a').on('click', function (e) {
        e.preventDefault();
        let $nav_item = $(this).parent();
        $nav_item.toggleClass('open');
        $nav_item.parent().toggleClass('sub_menu_open', $nav_item.hasClass('open'));
        $nav_item.find('.sub_menu').slideToggle({
            duration: 250,
            start: function () {
                var $sub_menu = $(this),
                    $nav_item = $sub_menu.closest('.nav_i');
                if ($nav_item.hasClass('nav_i-search') && $nav_item.hasClass('open')) {
                    $nav_item.find('input').trigger('focus');
                }
            }
        });
        $navs_items.filter('.open').not($nav_item).find('.sub_menu').slideUp({ duration: 250 });
        $navs_items.filter('.open').not($nav_item).removeClass('open');

        return false;
    });

    // function menu_close() {
    //     $navs_items.removeClass('open');
    //     $navs_items.find('.sub_menu').slideUp(250);
    // }

    // $overlay.on('click', function () {
    //     menu_close();
    // });

    // $("#barre-menu-principal .navbar .nav-item > a:not('#menu-billetterie, #542')").on('click', function () {
    //     var $navItem = $(this).closest('.nav-item'),
    //         isOpen = $navItem.hasClass('active')
    //     $nav = $navItem.closest('.navbar-nav'),
    //         $navItems = $nav.find('.nav-item'),
    //         $navLink = $navItem.closest('.nav-link');

    //     $navItems.removeClass('active');
    //     if (!isOpen)
    //         $navItem.addClass('active');
    //     return false;
    // });
    // Animation au scroll

    // Masquer alerte
    jQuery("#close-alert-header").click(function () {
        jQuery(".header-alert").hide();
        document.cookie = "alertCookie=hide; path=/";
    });

    // Show search pop-up
    jQuery(".search-activation, #bottom-mobile-menu-1-search, .search-popup #close-search-popup").on('click', function (event) {
        jQuery(".search-popup").toggleClass('search-popup-hidden');
        jQuery(".search-popup").toggleClass('search-popup-show');
    });

    //Search only if value
    jQuery("#search-popup-searchform input").on("keyup", function () {
        if (jQuery(this).val() != "") {
            jQuery("#search-popup-searchform button").removeAttr("disabled");
        }
    });
    // Show accessibility panel
    jQuery(".accessibility-activation").on('click', function (event) {
        jQuery("#submenu-accessibilite").toggleClass('top-bar-submenus-active');
    });
    //Display submenu on click on parent icon - DESKTOP
    // jQuery(".parent-top-bar-menu").on('click', function(event) {
    //     submenu_id = '#sub'+(this.id);
    //     jQuery(submenu_id).toggleClass('top-bar-submenus-active');
    //     jQuery(this).toggleClass('parent-top-bar-menu-open')

    //     current_menu_id = jQuery(this).attr('id');
    //     jQuery('.parent-top-bar-menu').each(function( index ) {
    //         if(current_menu_id != jQuery(this).attr('id'))
    //         {
    //             if(jQuery(this).hasClass('parent-top-bar-menu-open'))
    //             {
    //                 jQuery(this).removeClass('parent-top-bar-menu-open')
    //                 submenu_id = '#sub'+(this.id);
    //                 jQuery(submenu_id).toggleClass('top-bar-submenus-active');
    //             }
    //         }
    //     });
    // });

    // Cookies accessibilité
    jQuery('.item-accessibilite-container input').change(function () {
        getToggleVale(this);
    });

    // Mobile menu
    jQuery(".menu-mobile-head-right").on('click', function (event) {
        jQuery(".menu-mobile-head-right").toggleClass('menu-mobile-close');
        jQuery(".menu-mobile-head-right").toggleClass('menu-mobile-open');
        jQuery("#barre-menu-mobile").toggleClass('hide-mobile-menu');
        jQuery("#barre-menu-mobile").toggleClass('show-mobile-menu');
    });

    jQuery(".menu-mobile-right").on('click', function (event) {
        jQuery(".menu-mobile-right").toggleClass('menu-mobile-close');
        jQuery(".menu-mobile-right").toggleClass('menu-mobile-open');
        jQuery("#barre-menu-mobile").toggleClass('hide-mobile-menu');
        jQuery("#barre-menu-mobile").toggleClass('show-mobile-menu');
    });

    // var idMenuMobileTimeOut = false;
    // $triggerMobile.on('click', function (e) {
    //     e.preventDefault();
    //     menu_mobile_toggle();
    // });

    // function menu_mobile_toggle() {
    //     if ($html.hasClass('has-menuMobileOpen')) {
    //         menu_mobile_close();
    //     } else {
    //         menu_mobile_open();
    //     }
    // }

    // function menu_mobile_open() {
    //     if (!$html.hasClass('is-scrollBlockedMobile')) {
    //         sauvScroll = scrollT;
    //         idMenuMobileTimeOut = w.setTimeout(function () {
    //             w.scrollTo(0, 0);
    //             $html.addClass('is-scrollBlockedMobile');
    //         }, 500);
    //     }
    //     $html.addClass('has-menuMobileOpen');
    // }

    // function menu_mobile_close() {
    //     if (idMenuMobileTimeOut) w.clearTimeout(idMenuMobileTimeOut);
    //     $html.removeClass('is-scrollBlockedMobile');
    //     // closeSubMenu();
    //     w.scrollTo(0, sauvScroll);
    //     w.setTimeout(function () {
    //         $html.removeClass('has-menuMobileOpen');
    //     }, 50);
    // }

    //Display submenu mobile on click on parent
    // jQuery(".mobile-menu-line").on('click', function (event) {
    //     jQuery(this).toggleClass('mml-active');
    // });
    //Accessibilite mobile
    jQuery("#bottom-mobile-menu-1-accessibilite").on('click', function (event) {
        jQuery('.menu-mobile-accessibilite').toggleClass('menu-mobile-accessibilite-hide');
    });
    //Menu mobile pro
    jQuery("#mm2left img").on('click', function (event) {
        jQuery("#mm2leftcontent").toggleClass('hidem2l');
        jQuery("#mm2left").toggleClass('actm2l');
        jQuery("#mm2rightcontent").addClass('hidem2r');
        jQuery("#mm2right").removeClass('actm2r');
    });
    //Menu mobile ressources
    jQuery("#mm2right img").on('click', function (event) {
        jQuery("#mm2rightcontent").toggleClass('hidem2r');
        jQuery("#mm2right").toggleClass('actm2r');
        jQuery("#mm2left").removeClass('actm2l');
        jQuery("#mm2leftcontent").addClass('hidem2l');
    });
    //Slider home dates gestion flèches
    jQuery('.home-slider-calendrier-prev img').on('click', function (event) {
        jQuery("#home-slider-calendrier .swiper-button-prev").click();
    });
    jQuery('.home-slider-calendrier-next img').on('click', function (event) {
        jQuery("#home-slider-calendrier .swiper-button-next").click();
    });
    //Slider calendrier dates gestion flèches
    jQuery('.slider-calendrier-prev img').on('click', function (event) {
        jQuery("#slider-calendrier .swiper-button-prev").click();
    });
    jQuery('.slider-calendrier-next img').on('click', function (event) {
        jQuery("#slider-calendrier .swiper-button-next").click();
    });

    //Création slider dates home
    var swiper_home_date = new Swiper("#slider-home-dates-container", {
        slidesPerView: 3,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
            nextEl: "#slider-home-dates-container .swiper-button-next",
            prevEl: "#slider-home-dates-container .swiper-button-prev",
        },
        slideToClickedSlide: true,
        // centeredSlides: true,
        breakpoints: {
            769: {
                slidesPerView: 3,
                spaceBetween: 0,
                slidesPerGroup: 1,
            },
            993: {
                slidesPerView: 5,
                spaceBetween: 0,
                slidesPerGroup: 1,
            },
            1201: {
                slidesPerView: 6,
                spaceBetween: 20,
                slidesPerGroup: 1,
            }
        }
    });

    //Création slider dates calendrier
    var swiper_date = new Swiper("#slider-dates-container", {
        slidesPerView: 3,
        spaceBetween: 0,
        slidesPerGroup: 1,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
            nextEl: "#slider-dates-container .swiper-button-next",
            prevEl: "#slider-dates-container .swiper-button-prev",
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        breakpoints: {
            769: {
                slidesPerView: 3,
                spaceBetween: 0,
                slidesPerGroup: 1,
            },
            993: {
                slidesPerView: 5,
                spaceBetween: 0,
                slidesPerGroup: 1,
            },
            1201: {
                slidesPerView: 7,
                spaceBetween: 0,
                slidesPerGroup: 1,
            }
        }
    });
    //Gestion changement slide home
    swiper_home_date.on('slideChangeTransitionEnd', function () {
        date_active = jQuery('#slider-home-dates-container .swiper-slide-active').attr("data-date");
        jQuery('.home-calendrier-date-container').each(function (index) {
            jQuery(this).hide();
        });
        jQuery('.calendrier-' + date_active).show();
        jQuery('#home-calendier-date').removeClass('home-calendier-date-hide');
    });
    //Gestion changement slide calendrier
    swiper_date.on('slideChangeTransitionEnd', function () {
        mois_actif = jQuery('#slider-dates-container .swiper-slide-active').attr("data-month-name");
        jQuery('.calendar-month').each(function (index) {
            jQuery(this).removeClass('calendar-show');
            jQuery(this).addClass('calendar-hide');
        });
        jQuery('#' + mois_actif).removeClass('calendar-hide');
        jQuery('#' + mois_actif).addClass('calendar-show');
        jQuery('html, body').animate({
            scrollTop: jQuery('#' + mois_actif).offset().top - 120
        }, 500);
    });
    //Masquer calendrier date home
    jQuery("#close-home-calendrier").on('click', function (event) {
        jQuery('#home-calendier-date').toggleClass('home-calendier-date-hide');
    });

    jQuery("#slider-home-dates-container .swiper-slide").on('click', function (event) {
        date_active = jQuery(this).attr("data-date");
        if (jQuery(this).hasClass('swiper-slide-active')) {
            jQuery('.home-calendrier-date-container').each(function (index) {
                jQuery(this).hide();
            });
            jQuery('.calendrier-' + date_active).show();
            jQuery('#home-calendier-date').removeClass('home-calendier-date-hide');
        }


    });


    if (jQuery("#searchAjaxCustom2")[0]) {
        jQuery("#searchAjaxCustom2").click();
    }

    //Filtre page d'accueil
    var home_filters = new Array();
    jQuery(".home-saison-filters-button").on('click', function (event) {
        if (jQuery(".home")[0]) {
            cat = this.name;
            catName = '.carte-spectacle-live.' + cat;
            catNameOld = '.carte-spectacle-old.' + cat;
            jQuery(this).toggleClass('active-filter');
            if (home_filters.includes(catName)) {
                var index = home_filters.indexOf(catName);
                if (index !== -1) {
                    home_filters.splice(index, 1);
                }
            }
            else {
                home_filters.push(catName);
            }
            jQuery('.carte-spectacle-live').each(function (index) {
                jQuery(this).addClass('not-display');
                jQuery(this).removeClass('allow-display');
                jQuery(this).removeClass('can-display');
                jQuery(this).hide();
            });
            jQuery('.carte-spectacle-old').each(function (index) {
                jQuery(this).addClass('not-display');
                jQuery(this).removeClass('allow-display');
                jQuery(this).removeClass('can-display');
                jQuery(this).hide();
            });
            home_filters.forEach(cat_name => {

                jQuery(cat_name).each(function (index) {
                    jQuery(this).addClass('can-display')
                });
                cat_old = cat_name.replace("live", "old");
                jQuery(cat_old).each(function (index) {
                    jQuery(this).addClass('can-display')
                });
            });

            show_cards_nb = 0;
            jQuery('.can-display').each(function (index) {
                jQuery(this).addClass('allow-display');
            });
            while (show_cards_nb < 6) {
                jQuery('.carte-spectacle-live.allow-display').first().removeClass('allow-display').show();
                jQuery('.carte-spectacle-old.allow-display').first().removeClass('allow-display').show();
                show_cards_nb++;
            }

            if (home_filters.length > 0) {
                jQuery('.clean-home-saison-filters-button').show();
            }
            else {
                jQuery('.clean-home-saison-filters-button').hide();
            }
            jQuery('.carte-spectacle-voir-plus').show();
            jQuery('.carte-spectacle-voir-plus-old').show();
            if (!jQuery(".not-display")[0]) {
                jQuery('.carte-spectacle-voir-plus').hide();
                jQuery('.carte-spectacle-voir-plus-old').hide();
            }
            if (home_filters.length < 1) {
                jQuery('.clean-home-saison-filters-button').click();
            }

        }
    });
    //Public filter system
    var filters = new Array();
    jQuery(".home-saison-filters-button").on('click', function (event) {
        if (!jQuery(".home")[0]) {
            cat = this.name;
            catName = '.colonnePublic.' + cat;
            jQuery(this).toggleClass('active-filter');
            if (filters.includes(catName)) {
                var index = filters.indexOf(catName);
                if (index !== -1) {
                    filters.splice(index, 1);
                }
            }
            else {
                filters.push(catName);
            }
            displayCategoriesPublics(filters);
        }
    });
    jQuery(".slide-pass-abonnement-lien").on('click', function (event) {
        var href = jQuery(this).attr('data-link');
        window.open(href, '_blank');
    })
    //Vider filtres page d'accueil
    jQuery(".clean-home-saison-filters-button").on('click', function (event) {
        if (jQuery(".home")[0]) {
            jQuery('.home-saison-filters-button').each(function (index) {
                jQuery(this).removeClass('active-filter');
            });
            jQuery('.carte-spectacle-live').each(function (index) {
                jQuery(this).addClass('not-display').hide();
                jQuery(this).removeClass('can-display').hide();
            });
            jQuery('.carte-spectacle-old').each(function (index) {
                jQuery(this).addClass('not-display').hide();
                jQuery(this).removeClass('can-display').hide();
            });
            jQuery('.clean-home-saison-filters-button').hide();
            jQuery('.carte-spectacle-voir-plus').show();
            jQuery('.carte-spectacle-voir-plus-old').show();
            home_filters = [];
            spectacle_show = 0;
            while (spectacle_show < 6) {
                jQuery('.carte-spectacle-live.not-display').first().removeClass('not-display').show();
                jQuery('.carte-spectacle-old.not-display').first().removeClass('not-display').show();
                spectacle_show++;
            }
            if (jQuery(".next-saison.not-display")[0]) {
                spectacle_show_next = 0;
                while (spectacle_show_next < 6) {
                    jQuery('.next-saison.not-display').first().removeClass('not-display').show();
                    spectacle_show_next++;
                }
            }
        }
        else {
            jQuery('.home-saison-filters-button').each(function (index) {
                jQuery(this).removeClass('active-filter');
            });
            jQuery('.colonnePublic').each(function (index) {
                jQuery(this).show();
            });
            jQuery('.clean-home-saison-filters-button').hide();
        }
    })
    //accordeon
    jQuery(".common-accordeon-line").on('click', function (event) {

        if (!jQuery('.page-template-page-emplois')[0]) {
            jQuery(this).toggleClass('common-accordeon-status-open');
        }
    });
    jQuery(".page-template-page-emplois .common-accordeon-line #open-accordeon").on('click', function (event) {
        jQuery(this).parent().parent().parent().toggleClass('common-accordeon-status-open');
    });
    jQuery(".page-template-page-emplois .common-accordeon-line .common-accordeon-title").on('click', function (event) {
        jQuery(this).parent().parent().parent().toggleClass('common-accordeon-status-open');
    });
    //Fermer accordeon
    jQuery(".page-template-page-emplois .common-accordeon-line #close-accordeon").on('click', function (event) {
        jQuery(this).parent().parent().parent().toggleClass('common-accordeon-status-open');
    });
    // Création slider gallery
    var swiper_gallery = new Swiper('#slider-gallery-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        pagination: {
            el: '#slider-gallery .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '#slider-gallery .swiper-button-next',
            prevEl: '#slider-gallery .swiper-button-prev'
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: true,
            pauseOnMouseEnter: true,
        },
        loop: true,
        watchSlidesProgress: true
    });
    // Création slider ateliers
    var swiper_atelier = new Swiper('#slider-atelier-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        pagination: {
            el: '#slider-atelier .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '#slider-atelier .swiper-button-next',
            prevEl: '#slider-atelier .swiper-button-prev'
        },
        autoplay: {
            delay: 10000,
            disableOnInteraction: false
        },
        loop: true,
        watchSlidesProgress: true
    });
    // Création slider actualites
    var swiper_actus = new Swiper('#slider-actus-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        pagination: {
            el: '#slider-actus .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '#slider-actus .swiper-button-next',
            prevEl: '#slider-actus .swiper-button-prev'
        },
        // autoplay: {
        // delay: 10000,
        //     disableOnInteraction: false
        // },
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 10,
                slidesPerGroup: 2,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
                slidesPerGroup: 3,
            }
        },
        loop: true,
        watchSlidesProgress: true
    });
    //Toggle Switch Pass et abonnements
    jQuery(".slider-switch-pass-abonnements").click(function () {
        jQuery('#pass-abonnements').toggleClass("passToggle");
        jQuery('#pass-abonnements').toggleClass("abonnementsToggle");
        jQuery('#publicIndiv').toggleClass("hide-public");
        jQuery('#imgIndiv').toggleClass("hide-public");
        jQuery('#publicGp').toggleClass("hide-public");
        jQuery('#imgGp').toggleClass("hide-public");
        jQuery('.switch-pass').toggleClass("switch-public-active");
        jQuery('.switch-abonnements').toggleClass("switch-public-active");

    });
    // Création slider Pass
    var swiper_pass = new Swiper('#slider-pass-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        pagination: {
            el: '#slider-pass-container .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '#slider-pass-container .swiper-button-next',
            prevEl: '#slider-pass-container .swiper-button-prev'
        },
        // autoplay: {
        // delay: 10000,
        //     disableOnInteraction: false
        // },
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 10,
                slidesPerGroup: 2,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
                slidesPerGroup: 3,
            }
        },
        // loop: true,
        watchSlidesProgress: true
    });
    // Création slider abonnements
    var swiper_abos = new Swiper('#slider-abos-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        pagination: {
            el: '#slider-abos-container .swiper-pagination',
            clickable: true
        },
        navigation: {
            nextEl: '#slider-abos-container .swiper-button-next',
            prevEl: '#slider-abos-container .swiper-button-prev'
        },
        // autoplay: {
        // delay: 10000,
        //     disableOnInteraction: false
        // },
        breakpoints: {
            992: {
                slidesPerView: 2,
                spaceBetween: 10,
                slidesPerGroup: 2,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
                slidesPerGroup: 3,
            }
        },
        // loop: true,
        watchSlidesProgress: true
    });

    // Add smooth scrolling to top button
    jQuery(".go-to-top").on('click', function (event) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    jQuery("#spectacle-presentation").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery(".spectacle-presentation").offset().top - 120
        }, 500);
    });
    jQuery("#pass-et-abos").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#pass-abonnements").offset().top - 120
        }, 500);
    });
    jQuery("#spectacle-galerie").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#common-gallery").offset().top - 120
        }, 500);
    });
    jQuery("#spectacle-avec-vous").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery(".spectacle-avec-vous").offset().top - 120
        }, 500);
    });
    jQuery("#spectacle-distribution").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery(".spectacle-distribution").offset().top - 120
        }, 500);
    });
    jQuery("#recherche-programmation").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#search-programmation").offset().top - 120
        }, 500);
    });
    jQuery("#recherche-ateliers").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#search-ateliers").offset().top - 120
        }, 500);
    });
    jQuery("#recherche-ressources").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#search-ressources").offset().top - 120
        }, 500);
    });
    jQuery("#recherche-archives").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#search-archives").offset().top - 120
        }, 500);
    });
    jQuery("#recherche-autres").on('click', function (event) {
        jQuery('html, body').animate({
            scrollTop: jQuery("#search-autres").offset().top - 120
        }, 500);
    });
    jQuery("#voir-tout-programmation").on('click', function (event) {
        jQuery('#voir-tout-programmation').hide();
        jQuery('#voir-moins-programmation').show();
        jQuery('#search-programmation .carte-spectacle').each(function () {
            jQuery(this).show();
            jQuery(this).addClass('programmation-hide');
        });
    });
    jQuery("#voir-moins-programmation").on('click', function (event) {
        jQuery('#voir-tout-programmation').show();
        jQuery('#voir-moins-programmation').hide();
        jQuery('#search-programmation .carte-spectacle').each(function () {
            jQuery(this).hide();
        });
        i = 0;
        while (i < 6) {
            jQuery('.programmation-hide').first().removeClass('programmation-hide').show();
            i++;
        }
    });
    jQuery("#voir-tout-ateliers").on('click', function (event) {
        jQuery('#voir-tout-ateliers').hide();
        jQuery('#voir-moins-ateliers').show();
        jQuery('#search-ateliers .calendar-event-line').each(function () {
            jQuery(this).show();
            jQuery(this).addClass('ateliers-hide');
        });
    });
    jQuery("#voir-moins-ateliers").on('click', function (event) {
        jQuery('#voir-tout-ateliers').show();
        jQuery('#voir-moins-ateliers').hide();
        jQuery('#search-ateliers .calendar-event-line').each(function () {
            jQuery(this).hide();
        });
        i = 0;
        while (i < 6) {
            jQuery('.ateliers-hide').first().removeClass('ateliers-hide').show();
            i++;
        }
    });
    jQuery("#voir-tout-ressources").on('click', function (event) {
        jQuery('#voir-tout-ressources').hide();
        jQuery('#voir-moins-ressources').show();
        jQuery('#search-ressources .dossiers-pedagogique-line').each(function () {
            jQuery(this).show();
            jQuery(this).addClass('ressources-hide');
        });
    });
    jQuery("#voir-moins-ressources").on('click', function (event) {
        jQuery('#voir-tout-ressources').show();
        jQuery('#voir-moins-ressources').hide();
        jQuery('#search-ressources .dossiers-pedagogique-line').each(function () {
            jQuery(this).hide();
        });
        i = 0;
        while (i < 6) {
            jQuery('#search-ressources .ressources-hide').first().removeClass('ressources-hide').show();
            i++;
        }
    });
    jQuery("#voir-tout-archives").on('click', function (event) {
        jQuery('#voir-tout-archives').hide();
        jQuery('#voir-moins-archives').show();
        jQuery('#search-archives .calendar-event-line').each(function () {
            jQuery(this).show();
            jQuery(this).addClass('archives-hide');
        });
    });
    jQuery("#voir-moins-archives").on('click', function (event) {
        jQuery('#voir-tout-archives').show();
        jQuery('#voir-moins-archives').hide();
        jQuery('#search-archives .calendar-event-line').each(function () {
            jQuery(this).hide();
        });
        i = 0;
        while (i < 6) {
            jQuery('#search-archives .archives-hide').first().removeClass('archives-hide').show();
            i++;
        }
    });
    jQuery("#voir-tout-autres").on('click', function (event) {
        jQuery('#voir-tout-autres').hide();
        jQuery('#voir-moins-autres').show();
        jQuery('#search-autres .calendar-event-line').each(function () {
            jQuery(this).show();
            jQuery(this).addClass('autres-hide');
        });
    });
    jQuery("#voir-moins-autres").on('click', function (event) {
        jQuery('#voir-tout-autres').show();
        jQuery('#voir-moins-autres').hide();
        jQuery('#search-autres .calendar-event-line').each(function () {
            jQuery(this).hide();
        });
        i = 0;
        while (i < 6) {
            jQuery('#search-autres .autres-hide').first().removeClass('autres-hide').show();
            i++;
        }
    });

    // Show news pop-up
    // jQuery(".boutonSuivreNewsletter button").on('click', function(event) {
    //     jQuery(".news-popup").toggleClass('news-popup-hidden');
    //     jQuery(".news-popup").toggleClass('news-popup-show');
    // });
    // Show news pop-up
    jQuery(".boutonSuivreNewsletter").on('click', function (event) {
        jQuery(".news-popup").toggleClass('news-popup-hidden');
        jQuery(".news-popup").toggleClass('news-popup-show');
    });
    // Hide news pop-up
    jQuery(".news-popup #close-news-popup").on('click', function (event) {
        jQuery(".news-popup").toggleClass('news-popup-hidden');
        jQuery(".news-popup").toggleClass('news-popup-show');
    });

    //Voir plus presentation
    jQuery(".presentation-voir-plus span").on('click', function (event) {
        jQuery('.spectacle-presentation-haut').toggleClass('spectacle-presentation-haut-opacity');
        jQuery('.presentation-voir-plus').hide();
    });
    jQuery(".presentation-voir-plus img").on('click', function (event) {
        jQuery('.spectacle-presentation-haut').toggleClass('spectacle-presentation-haut-opacity');
        jQuery('.presentation-voir-plus').hide();
    });
    //Voir plus distribution
    jQuery(".distribution-voir-plus span").on('click', function (event) {
        jQuery('.spectacle-distribution').toggleClass('spectacle-distribution-opacity');
        jQuery('.distribution-voir-plus').hide();
    });
    jQuery(".distribution-voir-plus img").on('click', function (event) {
        jQuery('.spectacle-distribution').toggleClass('spectacle-distribution-opacity');
        jQuery('.distribution-voir-plus').hide();
    });

    //Voir plus faq
    jQuery(".faq-voir-plus span").on('click', function (event) {
        jQuery('.common-accordeon-line').each(function () {
            jQuery(this).show();
            jQuery('#common-accordeon .col.faq-voir-plus').hide();
        });
    })
    //Voir plus faq
    jQuery(".faq-voir-plus img").on('click', function (event) {
        jQuery('.common-accordeon-line').each(function () {
            jQuery(this).show();
            jQuery('#common-accordeon .col.faq-voir-plus').hide();
        });
    });
    //Faq scroll
    jQuery(".faq-line-question-most").click(function () {
        jQuery(".faq-voir-plus img").click();
        qst_id = jQuery(this).attr('id');
        jQuery('html, body').animate({
            scrollTop: jQuery("#see" + qst_id).offset().top - 120
        }, 500);
        jQuery(function () {
            jQuery("#see" + qst_id + ' #open-accordeon').click();
        });

    });
    //recherche faq
    jQuery("#reqFaq").on('click', function (event) {
        var search = jQuery('#reqFaqtxt').val();
        const myArray = search.split(" ");


        var count = 0;
        jQuery('.common-accordeon-line').each(function () {
            var currentElement = jQuery(this);

            const myDiv = currentElement.text().split(" ");
            var value = currentElement.text(); // if it is an input/select/textarea field
            ret = findCommonElement(myArray, myDiv)
            if (ret) {
                currentElement.show();
                count++;
            }
            else {
                currentElement.hide();
            }
            jQuery('#common-accordeon .faq-voir-plus').hide();
            if (count > 0) {
                jQuery('#common-accordeon .faq-ecrivez-nous').hide();
            }
            else {
                jQuery('#common-accordeon .faq-ecrivez-nous').show();
            }
        });
    });
    jQuery('#reqFaqtxt').keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            jQuery('#reqFaq').click();
            return false;
        }
    });

    jQuery('.spectacle-details-partager span').on('click', function (event) {
        jQuery('.spectacle-details-partager-share').toggleClass('spectacle-details-partager-share-hide');
    });
    jQuery('.spectacle-details-partager img').on('click', function (event) {
        jQuery('.spectacle-details-partager-share').toggleClass('spectacle-details-partager-share-hide');
    });

    // Hide reservation pop-up
    jQuery('.buttonReservationFinal').on('click', function (event) {
        id_need = jQuery(this).attr('id');
        id_clean = jQuery(this).attr('data-atelier-id');
        dateSelected = 0
        jQuery('.' + id_need).each(function (index) {
            if (jQuery(this).prop('checked')) {
                lien = jQuery(this).attr("data-lien-reservation");
                window.open(lien, '_blank');
                dateSelected++;
            }
        });
        if (dateSelected < 1) {
            jQuery('.atelier-texte-error').show();
        }
        else {
            jQuery('.atelier-texte-error').hide();
            jQuery('.atelier-popup-' + id_clean).toggleClass('atelier-popup-hidden');
            jQuery('.atelier-popup-' + id_clean).toggleClass('atelier-popup-show');
        }

    });

    // Show reservation pop-up
    // Open reservation page
    jQuery('.buttonReservationActive').on('click', function (event) {
        lien_clean = jQuery(this).attr('data-lien-resa');
        if (lien_clean != undefined) {
            window.open(lien_clean, '_blank');
        }
        // jQuery('.atelier-popup-'+id_clean).toggleClass('atelier-popup-hidden');
        // jQuery('.atelier-popup-'+id_clean).toggleClass('atelier-popup-show');
    });

    // Hide reservation pop-up
    jQuery('.close-atelier-popup').on('click', function (event) {
        id_clean = jQuery(this).attr('id');
        jQuery('.atelier-popup-' + id_clean).toggleClass('atelier-popup-hidden');
        jQuery('.atelier-popup-' + id_clean).toggleClass('atelier-popup-show');
    });


    jQuery(".calendar-month.calendar-show .mois").on('click', function (event) {
        jQuery(this).parent().toggleClass('calendar-show');
        jQuery(this).parent().toggleClass('calendar-hide');
    });
    jQuery(".calendar-month.calendar-hide .mois").on('click', function (event) {
        jQuery(this).parent().toggleClass('calendar-show');
        jQuery(this).parent().toggleClass('calendar-hide');
    });

    jQuery(".onglet_title").on('click', function (event) {
        actualId = jQuery(this).attr('id');
        jQuery('#' + actualId + '.onglet_content').show();
        jQuery(".onglet_title").each(function () {
            jQuery(this).removeClass('onglet_actif');
        });
        jQuery(".onglets_list").each(function () {
            parseId = jQuery(this).val()
            if (parseId != actualId) {
                jQuery('#' + parseId + '.onglet_content').hide();
            }
        });
        jQuery(this).addClass('onglet_actif');
    });
    jQuery(".changeOnglet").on('click', function (event) {
        actualId = jQuery(this).attr('id');
        jQuery('#' + actualId + '.onglet_title').click();
        jQuery('html, body').animate({
            scrollTop: jQuery('#mecenecontent').offset().top - 200
        }, 500);
    });
    // jQuery(document).on('click', function(event) {
    //     $navItems.removeClass( 'active' );
    // });
    // jQuery(".dropdown-social").on('click', function(event) {
    //     jQuery('.dropdown-menu').css({"display": "none"});
    //     setTimeout(function() { 
    //         jQuery('.dropdown-menu').removeAttr('style');
    //     }, 1800);
    // });
    jQuery('.nav-link').each(function () {
        const navID = jQuery(this).attr('id');
        if (navID) {
            if (jQuery('body').hasClass('page-id-' + navID) || jQuery('body').hasClass('parent-pageid-' + navID)) {
                jQuery('#' + navID + '.nav-link').addClass('active-nav-link');
            }
        }
    });

    const locationUrl = jQuery('#menu-menu-footer-1 li:last-child a').attr("href") + '?type=location';
    jQuery('#menu-menu-footer-1 li:last-child a').attr("href", locationUrl);


    //Voir plus home
    // jQuery(".carte-spectacle-voir-plus span").on('click', function (event) {
    //     var type = "";
    //     var cards = "";
    //     if (jQuery(".home")[0]) {
    //         type = jQuery(this).parent().attr('data-voir-plus');
    //         cards = jQuery(this).parent().attr('data-cards');
    //         if (home_filters.length === 0) {
    //             jQuery('.home-saison-filters-button').each(function (index) {
    //                 jQuery(this).removeClass('active-filter');
    //             });
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 if (cards != undefined) {
    //                     jQuery(cards + '.not-display').first().removeClass('not-display').show();
    //                 }
    //                 else {
    //                     jQuery('.not-display').first().removeClass('not-display').show();
    //                 }
    //                 spectacle_show++;
    //             }
    //             if (cards != undefined) {
    //                 var slide_cards = cards.replace(' .carte-spectacle', '').replace('-live', '').replace('-old', '');
    //                 if (!jQuery(cards + ".not-display")[0]) {
    //                     jQuery(slide_cards + ' .carte-spectacle-voir-plus').hide();
    //                 }
    //             }
    //             else if (!jQuery(".not-display")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus').hide();
    //             }
    //         }
    //         else {
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 if (cards != undefined) {
    //                     jQuery(cards + '.allow-display').first().removeClass('allow-display').show();
    //                 }
    //                 else {
    //                     jQuery('.allow-display').first().removeClass('allow-display').show();
    //                 }
    //                 spectacle_show++;
    //             }
    //             if (cards != undefined) {
    //                 var slide_cards = cards.replace(' .carte-spectacle', '').replace('-live', '').replace('-old', '');
    //                 if (!jQuery(cards + ".allow-display")[0]) {
    //                     jQuery(slide_cards + ' .carte-spectacle-voir-plus').hide();
    //                 }
    //             }
    //             else if (!jQuery(".allow-display")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus').hide();
    //             }
    //         }
    //         setSliderHomeHeight(type);
    //     }
    // })
    // //Voir plus home 
    // jQuery(".carte-spectacle-voir-plus img").on('click', function (event) {
    //     var type = "";
    //     var cards = "";
    //     if (jQuery(".home")[0]) {
    //         type = jQuery(this).parent().attr('data-voir-plus');
    //         cards = jQuery(this).parent().attr('data-cards');
    //         if (home_filters.length === 0) {
    //             jQuery('.home-saison-filters-button').each(function (index) {
    //                 jQuery(this).removeClass('active-filter');
    //             });
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 if (cards != undefined) {
    //                     jQuery(cards + '.not-display').first().removeClass('not-display').show();
    //                 }
    //                 else {
    //                     jQuery('.not-display').first().removeClass('not-display').show();
    //                 }
    //                 spectacle_show++;
    //             }
    //             if (cards != undefined) {
    //                 var slide_cards = cards.replace(' .carte-spectacle', '').replace('-live', '').replace('-old', '');
    //                 if (!jQuery(cards + ".not-display")[0]) {
    //                     jQuery(slide_cards + ' .carte-spectacle-voir-plus').hide();
    //                 }
    //             }
    //             else if (!jQuery(".not-display")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus').hide();
    //             }
    //         }
    //         else {
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 if (cards != undefined) {
    //                     jQuery(cards + '.allow-display').first().removeClass('allow-display').show();
    //                 }
    //                 else {
    //                     jQuery('.allow-display').first().removeClass('allow-display').show();
    //                 }
    //                 spectacle_show++;
    //             }
    //             if (cards != undefined) {
    //                 var slide_cards = cards.replace(' .carte-spectacle', '').replace('-live', '').replace('-old', '');
    //                 if (!jQuery(cards + ".allow-display")[0]) {
    //                     jQuery(slide_cards + ' .carte-spectacle-voir-plus').hide();
    //                 }
    //             }
    //             if (cards != undefined) {
    //                 var slide_cards = cards.replace(' .carte-spectacle', '').replace('-live', '').replace('-old', '');
    //                 if (!jQuery(cards + ".allow-display")[0]) {
    //                     jQuery(slide_cards + ' .carte-spectacle-voir-plus').hide();
    //                 }
    //             }
    //             else if (!jQuery(".allow-display")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus').hide();
    //             }
    //         }
    //         setSliderHomeHeight(type);
    //     }
    // })
    // //Voir plus home old
    // jQuery(".carte-spectacle-voir-plus-old span").on('click', function (event) {
    //     var type = "";
    //     var cards = "";
    //     if (jQuery(".home")[0]) {
    //         type = jQuery(this).parent().attr('data-voir-plus');
    //         cards = jQuery(this).parent().attr('data-cards');
    //         if (home_filters.length === 0) {
    //             jQuery('.home-saison-filters-button').each(function (index) {
    //                 jQuery(this).removeClass('active-filter');
    //             });
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 if (cards != undefined) {
    //                     jQuery(cards + '.old-hide').first().removeClass('old-hide').show();
    //                 }
    //                 else {
    //                     jQuery('.old-hide').first().removeClass('old-hide').show();
    //                 }
    //                 spectacle_show++;
    //             }
    //             if (!jQuery(".carte-spectacle-old.old-hide")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus-old').hide();
    //             }
    //         }
    //         else {
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 jQuery('.carte-spectacle-old.allow-display').first().removeClass('old-hide').show();
    //                 spectacle_show++;
    //             }
    //             if (!jQuery(".carte-spectacle-old.allow-display")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus-old').hide();
    //             }
    //         }
    //         setSliderHomeHeight(type);
    //     }
    // })
    // //Voir plus home old
    // jQuery(".carte-spectacle-voir-plus-old img").on('click', function (event) {
    //     var type = "";
    //     var cards = "";
    //     if (jQuery(".home")[0]) {
    //         type = jQuery(this).parent().attr('data-voir-plus');
    //         cards = jQuery(this).parent().attr('data-cards');
    //         if (home_filters.length === 0) {
    //             jQuery('.home-saison-filters-button').each(function (index) {
    //                 jQuery(this).removeClass('active-filter');
    //             });
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 if (cards != undefined) {
    //                     jQuery(cards + '.old-hide').first().removeClass('old-hide').show();
    //                 }
    //                 else {
    //                     jQuery('.old-hide').first().removeClass('old-hide').show();
    //                 }
    //                 spectacle_show++;
    //             }
    //             if (!jQuery(".carte-spectacle-old.old-hide")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus-old').hide();
    //             }
    //         }
    //         else {
    //             spectacle_show = 0;
    //             while (spectacle_show < 6) {
    //                 jQuery('.carte-spectacle-old.allow-display').first().removeClass('old-hide').show();
    //                 spectacle_show++;
    //             }
    //             if (!jQuery(".carte-spectacle-old.allow-display")[0]) {
    //                 jQuery('.carte-spectacle-voir-plus-old').hide();
    //             }
    //         }
    //         setSliderHomeHeight(type);
    //     }
    // })

    var $postsAtelier = jQuery('.post-atelier');
    // console.log($postsAtelier);
    // console.log(jQuery('#filtre-atelier'));
    jQuery('#filtre-atelier').on('change', function () {
        var selected = jQuery(this).val();
        console.log(selected);
        $postsAtelier.hide(); // on les masque tous par défaut
        $postsAtelier.filter('[data-atelier*=";' + selected + ';"]').show(); // on affiche ceux qui correspondent au filtre choisi
    });

    // Slider home
    const $sliderHome = $('.slider.swiper-container'),
        sliderHome = $sliderHome.get(0),
        $swiperPagination = $sliderHome.find('.swiper-pagination'),
        swiperPagination = $swiperPagination.get(0),
        $swiperPaginationBullets = $swiperPagination.find('.swiper-pagination-bullet');

    var swiper_home_pagination;
    var swiper_home = new Swiper('.slider.swiper-container', {
        slidesPerView: 1,
        spaceBetween: 0,
        slidesPerGroup: 1,
        // direction: 'horizontal',
        effect: 'fade',
        pagination: {
            el: '.slider.swiper-container .swiper-pagination',
            type: 'custom',
            clickable: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        },
        // breakpoints: {
        //     850: {
        //         direction: 'vertical',
        //     },
        // },
        // loop: true,
        watchSlidesProgress: true,
        on: {
            slideChange: function (swiper) {
                $swiperPagination.removeClass('start-timer');
                $swiperPaginationBullets.filter('[data-slide-index=' + swiper.activeIndex + ']').trigger('click');
                $swiperPagination.addClass('start-timer');
                if (swiper_home_pagination) {
                    swiper_home_pagination.slideTo(swiper.activeIndex);
                }
            }
        },
    });

    function swiper_home_pagination_init() {
        if (window.innerWidth <= 850) {
            swiper_home_pagination = new Swiper('.slider.swiper-container .swiper-pagination', {
                slidesPerView: 1,
                spaceBetween: 0,
                slideToClickedSlide: true,
                initialSlide: swiper_home.activeIndex,
                on: {
                    slideChange: function (swiper) {
                        swiper_home.slideTo(swiper.activeIndex);
                    }
                }
            });
        } else if (swiper_home_pagination) {
            swiper_home_pagination.destroy();
        }
    }
    swiper_home_pagination_init();
    $(window).on('resize', swiper_home_pagination_init);

    $swiperPagination.addClass('start-timer');
    sliderHome.style.setProperty('--slider-padding-bottom', (swiperPagination.offsetHeight + window.innerWidth * .1) + 'px');
    $swiperPaginationBullets.each(function () {
        const $swiperPaginationBullet = $(this);
        const swiperPaginationBullet = $swiperPaginationBullet.get(0);
        $swiperPaginationBullet.on('click', function () {
            $swiperPaginationBullets.removeClass('swiper-pagination-bullet-active');
            $swiperPaginationBullets.removeAttr('aria-current');
            $swiperPaginationBullet.addClass('swiper-pagination-bullet-active');
            $swiperPaginationBullet.attr('aria-current', true);
            swiperPagination.style.setProperty('--slider-nav-top', swiperPaginationBullet.offsetTop + 'px');
            swiperPagination.style.setProperty('--slider-nav-height', swiperPaginationBullet.offsetHeight + 'px');
        });
        $swiperPaginationBullet.on('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
                $swiperPaginationBullet.trigger('click');
                swiper_home.slideTo($swiperPaginationBullet.attr('data-slide-index'));
                if (swiper_home_pagination) {
                    swiper_home_pagination.slideTo($swiperPaginationBullet.attr('data-slide-index'));
                }
            }
        });
        if ($swiperPaginationBullet.hasClass('swiper-pagination-bullet-active')) {
            swiperPagination.style.setProperty('--slider-nav-top', swiperPaginationBullet.offsetTop + 'px');
            swiperPagination.style.setProperty('--slider-nav-height', swiperPaginationBullet.offsetHeight + 'px');
        }
    });
    $(window).on('resize', function () {
        sliderHome.style.setProperty('--slider-padding-bottom', (swiperPagination.offsetHeight + window.innerWidth * .1) + 'px');
        const swiperPaginationBullet = $swiperPaginationBullets.filter('.swiper-pagination-bullet-active').get(0);
        if (!swiperPaginationBullet) return;
        swiperPagination.style.setProperty('--slider-nav-top', swiperPaginationBullet.offsetTop + 'px');
        swiperPagination.style.setProperty('--slider-nav-height', swiperPaginationBullet.offsetHeight + 'px');
    });

    // Slider spectacles home
    var swiper_specs_home = new Swiper('.specs_content.swiper-container', {
        slidesPerView: 1.2,
        spaceBetween: 20,
        slidesPerGroup: 1.2,
        pagination: {
            el: '.specs_content.swiper-container .swiper-pagination',
            clickable: true
        },
        breakpoints: {
            500: {
                slidesPerView: 2.2,
                spaceBetween: 20,
                slidesPerGroup: 2.2,
            },
            750: {
                slidesPerView: 3.2,
                spaceBetween: 20,
                slidesPerGroup: 3.2,
            },
            1035: {
                slidesPerView: 3.2,
                spaceBetween: 40,
                slidesPerGroup: 3.2,
            },
        },
    });


    //Accordéons

    function acc_init($cont) {
        $cont = $cont && $cont.length ? $cont : $('#main');
        $cont.find('.acc:not(.js-acc)').addClass('js-acc');
        $cont.find('.js-acc:not(.is-init)').each(function (idx, el) {
            var $wrapper = $(el);
            var $head = $wrapper.find('.acc_head');
            var $cont = $wrapper.find('.acc_content');
            if (!$head.length || !$cont.length) return;
            $head.wrapInner('<button type="button"></button>');
            $wrapper.addClass('is-init').addClass('is-closed');
            $cont.hide();
            $head.on('click', 'button', function (event) {
                event.preventDefault();
                $cont.slideToggle(400);
                $wrapper.toggleClass('is-closed');
            });
        });
    }
    acc_init();

    var $adminBar;
    var adminBarVisibleHeight;
    var $window = $(window);
    var scrollT;
    var scrollUp = false;

    function update_scroll() {
        // pas de changement du sens du scroll si on a scrollé de moins de 5px
        scrollUp = Math.abs($window.scrollTop() - scrollT) < 5 ? scrollUp : $window.scrollTop() <= scrollT;
        scrollT = $window.scrollTop();
        $adminBar = $adminBar && $adminBar.length > 0 ? $adminBar : $('#wpadminbar');
        if ($adminBar && $adminBar.length > 0) {
            adminBarVisibleHeight = Math.max($adminBar.outerHeight() - scrollT + $adminBar.offset().top, 0) + 'px';
            document.documentElement.style.setProperty('--adminBarVisibleHeight', adminBarVisibleHeight);
        } else {
            document.documentElement.style.setProperty('--adminBarVisibleHeight', null);
        }
    }
    update_scroll();

});

function getToggleVale(toogle) {
    cookie_name = jQuery(toogle).attr('id');
    if (jQuery(toogle).prop('checked')) {
        document.cookie = cookie_name + "=on; path=/";
    }
    else {
        document.cookie = cookie_name + "=off; path=/";
    }
    jQuery("body").toggleClass(cookie_name);
    jQuery("html").toggleClass(cookie_name);
}

function showContent(content = null) {
    if (jQuery(".home")[0]) {
        show_content_nb = 0;
        jQuery('.can-display').each(function (index) {
            jQuery(this).addClass('allow-display');
        });
        while (show_content_nb < 6) {
            jQuery('.allow-display').first().removeClass('allow-display').show();
            show_content_nb++;
        }
    }
    else {
        jQuery(content).show();
    }

}
function displayCategoriesPublics(filters = null) {
    if (filters.length > 0) {
        jQuery('.colonnePublic').hide();
        filters.forEach(showContent);
        jQuery('.clean-home-saison-filters-button').show();
    }
    else {
        jQuery('.clean-home-saison-filters-button').hide();
        jQuery('.colonnePublic').each(function (index) {
            jQuery(this).show();
        });
    }
}
function findCommonElement(array1, array2) {

    // Loop for array1
    for (let i = 0; i < array1.length; i++) {

        // Loop for array2
        for (let j = 0; j < array2.length; j++) {

            // Compare the element of each and
            // every element from both of the
            // arrays
            if (array1[i] === array2[j]) {

                // Return if common element found
                return true;
            }
        }
    }

    // Return if no common element exist
    return false;
}

// function setSliderHomeHeight(type) {
//     if (type != undefined) {
//         height = jQuery('#' + type).height();
//         jQuery("#slider-home-spectacle-container .swiper-wrapper").height(height);
//     }
// }
